<script>
import { Cropper } from 'vue-advanced-cropper'
import { appConfig } from '@src/app.config'
import axios from 'axios'
import { BIconArrowClockwise } from 'bootstrap-vue'
import { services } from '@src/utils/common-services'

export default {
  components: {
    Cropper, // image cropper
    BIconArrowClockwise,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    user: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      type: String,
      default() {
        return ''
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    type: {
      type: String,
      default() {
        return 'file'
      },
    },
    validation: {
      type: String,
      default() {
        return ''
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      file: null,
      inter: false,
      savedFileUrl: null,
      showSuccess: null,
      isVerified: false,
      message: null,
      required: false,
      savedFile: {},
      //  resolution:null,
      validate: {},
      profile: null,
      image: false,
      img: null,
      ids: null,
      loading: false,
      saveLoading: false,
      changeFile: null,
      displayLabel: null,
      api: appConfig.apiUrl.split('/api/'),

      imageToCrop: null,
      fileType: null,
      storedData: null,
      canvas: null,
      displayUrl: null,
    }
  },
  watch: {
    value(oldVal, newVal) {
      //     console.log(this.value)
      if (this.value === null && this.ids !== null) {
        this.deleteFile()
      } else {
        this.ids = this.value
        this.getData(this.ids)
      }
    },
    file(oldVal, newVal) {
      //   this.resolution=null
      this.savedFile = Object.assign({})
      if (this.file !== null) {
        if (this.file.size === 0) {
          this.file = null
        }
      }
      if (this.file !== null) {
        // console.log(this.file.name)

        let arrayName = this.file.name.split('.')
        let array = this.options.acceptingFiles.split(', ')
        let type = arrayName[arrayName.length - 1].toUpperCase()

        if (array.indexOf(type) > -1) {
          this.fileType = type
          if (this.fileType === 'PDF') {
            this.storedData = this.getFiles('document', this.file)
            this.saveData()
            // console.log(fileType)
          } else if (this.fileType === 'DOC') {
            this.storedData = this.getFiles('document', this.file)
            this.saveData()
            // console.log(fileType)
          } else {
            //         console.log(fileType)
            if (
              this.fileType === 'PNG' ||
              this.fileType === 'JPEG' ||
              this.fileType === 'JPG'
            ) {
              this.loading = true
              this.inter = true
              const reader = new FileReader()
              reader.readAsDataURL(this.file)
              this.img = reader.result
              // console.log(this.file.naturalWidth)

              var parent = this
              setTimeout(() => {
                var ImageURL = reader.result
                /*  var width=0
                var height=0
var im= new Image()
im.src=reader.result
im.onload = function() {
        width=im.width
        height=im.height */
                //  if((height>0&&height<1000)&&(width>0&&width<1000)){
                parent.img = ImageURL
                parent.imageToCrop = ImageURL
                parent.inter = false
                parent.image = true
                /*  }
    else{ */
                /*   if((height>1000)||(width>1000)){
parent.resolution='The upload file is high in resolution. Free style cropping not available to this image.'
    } */
                //   };
              }, 1000)
            } else {
              this.storedData = this.getFiles('document', this.file)
              this.saveData()
            }
          }
        } else {
          // this.storedData = this.getFiles('document', this.file)
          // this.saveData()
        }
      } // else this.$emit('edit', { name: this.name, data: null })

      //   console.log(fileType)
    },
  },

  beforeMount() {
    //  this.validate=this.validation.ext
    //  console.log(typeof(this.validate))
    //   this.getData()
    // console.log(this.validation)
    // console.log(this.value)
    this.required = this.validation.includes('required')
    this.getUser()
    if (this.value !== '') {
      this.ids = this.value
      this.getData(this.ids)
    }
  },
  beforeDestroy() {
    /*   var doc = this.$refs['file' + this.name]
    if (doc !== undefined) doc.innerHTML = '' */
  },
  methods: {
    getUser() {
      this.profile = services.decodeJWT(services.getAuth())
      // console.log(this.profile)
    },
    change({ coordinates, canvas }) {
      this.canvas = canvas
    },
    skip() {
      this.image = !this.image

      this.loading = false

      this.inter = false
      this.storedData = this.getFiles('document', this.file)
      this.saveData()
    },
    cancel() {
      this.image = !this.image
      if (this.displayUrl !== null) {
        this.checkUrlFileType()
        this.img = null
      } else this.fileType = null
      this.loading = false
      this.file = null
      this.inter = false
    },
    setImage() {
      //  this.image = !this.image
      //    console.log('in crop')
      this.inter = false
      this.loading = false

      // this.saveLoading=true
      this.$refs[this.name].reset()

      var img = this.canvas.toDataURL('image/png')
      this.img = img
      this.image = false
      var block = img.split(';')
      // Get the content type of the image
      var contentType = block[0].split(':')[1]
      var profileImage = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = services.b64toBlob(profileImage, contentType, this.file.name)
      // this.$emit('update', { data: blob, type: 'file' })

      let files = new FormData()
      files.append('document', blob)
      this.storedData = files
      this.saveData()

      //  this.cancel('modal-profile-upload', '')
    },
    replaceFile() {
      document.getElementById(this.id).click()
    },
    removeFile() {
      // console.log('removeFile')
      this.message = 'Do you want to delete this file?'
      this.changeFile = 'delete'
      this.$bvModal.show(this.name)
    },
    callSignature() {
      this.$bvModal.show('show-signature')
    },
    checkUrlFileType() {
      this.fileType = this.displayLabel
        .substring(
          this.displayLabel.lastIndexOf('.') + 1,
          this.displayLabel.length
        )
        .toUpperCase()
      //  console.log(this.fileType)
    },
    fileChange(name) {
      this.$bvModal.hide(this.name)
      this.$bvModal.hide(this.name + this.ids + 'verify')

      if (name === 'verify') {
        this.sendVerify()
      } else this.deleteFile()
    },
    downloadFile() {
      /*  axios({
        url: this.api[0] + this.displayUrl,
        method: 'GET',
        responseType: 'blob', // important
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'attachment',
          Authorization: 'JWT ' + services.getAuth(),
        },
      }).then((response) => {
        //  console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data])) */
      const link = document.createElement('a')
      link.href = this.api[0] + this.displayUrl
      // console.log(link)
      link.setAttribute('download', this.displayLabel) // or any other extension
      document.body.appendChild(link)
      link.click()
      // })
    },
    deleteFile() {
      this.img = null
      this.fileType = null

      axios
        .delete(appConfig.formsUrl + '/document/' + this.ids, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'JWT ' + services.getAuth(),
          },
        })
        .then((response) => {
          this.ids = null
          this.displayLabel = null
          this.displayUrl = null
          this.file = null

          this.$emit('delete', { name: this.name, data: null })
        })
        .catch((error) => {
          if (error) {
          }
        })
    },
    sendVerify() {
      this.loading = true
      this.saveLoading = true
      axios
        .post(
          appConfig.formsUrl + '/document/verify',
          {
            attributes: {
              documentId: this.ids,
            },
          },
          {
            headers: { Authorization: 'JWT ' + services.getAuth() },
          }
        )
        .then((response) => {
          this.message = 'The file is verified'
          this.saveLoading = false
          this.isVerified = true
          this.showSuccess = true
          this.$bvToast.show('verify' + this.name + this.ids)
          var parent = this
          this.loading = false
          // console.log(response)
          this.displayUrl = response.data.attributes.verifiedDocumentUrl
          setTimeout(() => {
            parent.$bvToast.hide('verify' + this.name + this.ids)

            parent.message = null
          }, 4000)
        })
        .catch((error) => {
          if (error) {
            this.loading = false
            this.saveLoading = false
            //  console.log(error.response.data.message.errors[0].detail)
            if (error.response.data.message !== undefined)
              this.message = error.response.data.message.errors[0].detail
            else this.message = 'Something went wrong. Please check the file'
            this.showSuccess = false
            this.$bvToast.show('verify' + this.name + this.ids)
            var parent = this

            setTimeout(() => {
              parent.$bvToast.hide('verify' + this.name + this.ids)

              parent.message = null
            }, 4000)
          }
        })
    },
    verifyFile() {
      //  console.log('am here')
      // console.log(this.profile.signature)
      if (
        this.profile.signature !== undefined &&
        this.profile.signature !== null
      ) {
        this.message = 'Do you want to verify this file?'
        this.$bvModal.show(this.name + this.ids + 'verify')
        this.changeFile = 'verify'
      } else {
        var signatureFlag = services.getLocalStorage('signature')

        if (
          signatureFlag === undefined ||
          signatureFlag === null ||
          signatureFlag === false
        )
          this.callSignature()
        else {
          this.message = 'Do you want to verify this file?'
          this.$bvModal.show(this.name + this.ids + 'verify')
          this.changeFile = 'verify'
        }
      }
    },
    getData(id) {
      if (id !== null) {
        this.loading = true
        axios
          .get(appConfig.formsUrl + '/document/' + id, {
            headers: { Authorization: 'JWT ' + services.getAuth() },
          })
          .then((response) => {
            this.loading = false
            this.isVerified = response.data.attributes.isVerified

            //        console.log(response)
            if (this.isVerified)
              this.displayUrl = response.data.attributes.verifiedDocumentUrl
            else this.displayUrl = response.data.attributes.documentUrl

            this.displayLabel = response.data.attributes.documentLabel

            this.checkUrlFileType()
            //  console.log(this.fileType)
            //     console.log(this.displayUrl)
            this.ids =
              response.data._id.$oid === undefined
                ? response.data._id
                : response.data._id.$oid
            this.haveSavedData = true
          })
          .catch((error) => {
            this.loading = false
            if (error) {
              this.ids = null
            }
          })
      }
    },
    saveData() {
      if (this.ids !== null) this.putData()
      else this.postData()
    },
    postData() {
      //  console.log(this.storedData)
      this.loading = true
      this.saveLoading = true
      this.storedData.append('applicantId', this.user)
      this.storedData.append('documentType', this.name)
      axios
        .post(appConfig.formsUrl + '/document/' + this.user, this.storedData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'JWT ' + services.getAuth(),
          },
        })
        .then((response) => {
          this.loading = false
          this.saveLoading = false
          this.haveSavedData = true
          this.ids =
            response.data._id.$oid === undefined
              ? response.data._id
              : response.data._id.$oid
          this.displayUrl = response.data.attributes.documentUrl
          this.displayLabel = response.data.attributes.documentLabel
          this.isVerified = response.data.attributes.isVerified
          this.file = null
          this.$emit('edit', { name: this.name, data: this.ids })
        })
        .catch((error) => {
          this.saveLoading = false
          this.loading = false
          if (error) {
          }
        })
    },
    putData() {
      this.loading = true
      this.saveLoading = true
      this.storedData.append('documentId', this.ids)
      this.storedData.append('applicantId', this.user)
      this.storedData.append('documentType', this.name)
      axios
        .put(appConfig.formsUrl + '/document', this.storedData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'JWT ' + services.getAuth(),
          },
        })
        .then((response) => {
          this.haveSavedData = true
          this.loading = false
          this.saveLoading = false

          this.ids =
            response.data._id.$oid === undefined
              ? response.data._id
              : response.data._id.$oid
          this.displayUrl = response.data.attributes.documentUrl
          this.displayLabel = response.data.attributes.documentLabel
          this.file = null
          this.isVerified = response.data.attributes.isVerified
          this.$emit('edit', { name: this.name, data: this.ids })
        })
        .catch((error) => {
          this.saveLoading = false
          this.loading = false
          if (error) {
          }
        })
    },
    getFiles(name, event) {
      let file = event

      //    console.log(file)
      let files = new FormData()
      files.append(name, file)
      return files
      // console.log(name)
    },
  },
}
</script>
<template>
  <div
    :ref="'file' + name"
    :class="$style.formGroup"
    class="formGroup mt20 mt10-sm"
  >
    <div class="formFieldWrap">
      <label :for="name" :class="$style.fieldTitle">{{ label }} </label>

      <div :class="$style.formFileUpload">
        <ValidationProvider
          :ref="name"
          v-slot="{ errors, validate }"
          :mode="'aggressive'"
          :vid="name"
          :name="name + '_File'"
          :rules="
            file === null
              ? required
                ? displayUrl !== null
                  ? ''
                  : validation
                : ''
              : validation
          "
        >
          <b-form-file
            :id="id"
            v-model="file"
            :name="name"
            class="mb-2"
            @change="validate"
          ></b-form-file>
          <span v-show="errors[0]" :class="$style.error">{{ errors[0] }}</span>
        </ValidationProvider>
        <div :class="$style.fileStyle">
          <span :class="$style.fileImage"></span>
          <!-- <button :class="$style.fileUploadButton">Choose File</button> -->
          <div :class="$style.thumbNail">
            <!--  <img
              v-if="inter"
              src="@assets/images/defaultDoc.png"
              alt="Document"
            /> -->
            <img
              v-if="fileType === 'PDF'"
              src="@assets/images/pdf.png"
              alt="Document"
            />
            <img
              v-else-if="fileType === 'DOC'"
              src="@assets/images/defaultDoc.png"
              alt="Document"
            />

            <img
              v-else-if="
                !inter &&
                  (fileType === 'JPEG' ||
                    fileType === 'PNG' ||
                    fileType === 'JPG')
              "
              :src="
                img === null
                  ? displayUrl !== null
                    ? api[0] + displayUrl
                    : ''
                  : img
              "
              alt="Document"
            />

            <img v-else src="@assets/images/defaultDoc.png" alt="Document" />
          </div>

          <p v-if="displayLabel !== null" :class="$style.fileName">{{
            displayLabel !== null ? displayLabel : ''
          }}</p>
          <span v-else :class="$style.acceptFiles"
            >Click here to upload document</span
          >
          <div :class="$style.fileActions">
            <a
              v-if="displayUrl !== null"
              :id="'view' + id"
              :href="displayUrl !== null ? api[0] + displayUrl : ''"
              :target="displayUrl !== null ? '_blank' : ''"
              :class="[$style.fileActionButton]"
              ><BIcon class="db" icon="eye"></BIcon>
              <b-tooltip
                :target="'view' + id"
                variant="secondary"
                placement="bottom"
                >View</b-tooltip
              >
            </a>
            <a
              v-if="displayUrl !== null"
              :id="'download' + id"
              :class="[$style.fileActionButton]"
              @click="downloadFile"
              ><BIcon class="db" icon="download"></BIcon>
              <b-tooltip
                :target="'download' + id"
                variant="secondary"
                placement="bottom"
                >Download</b-tooltip
              >
            </a>
            <a
              v-if="profile.is_staff && !isVerified && displayUrl !== null"
              :id="'verify' + id"
              href="javascript:void(0)"
              :class="[$style.fileActionButton]"
              @click="verifyFile"
              ><BIcon class="db" icon="check2"></BIcon>
              <b-tooltip
                :target="'verify' + id"
                variant="secondary"
                placement="bottom"
                >Verify</b-tooltip
              >
            </a>

            <!-- <a id="remove" href="#" :class="[$style.fileActionButton]"
              ><BIcon class="" icon="trash"></BIcon>
              <b-tooltip target="remove" variant="secondary" placement="bottom"
                >Delete</b-tooltip
              >
            </a> -->
            <a
              v-if="displayUrl !== null && required"
              :id="'replace' + id"
              :class="[$style.fileActionButton]"
              @click="replaceFile"
            >
              <BIconArrowClockwise></BIconArrowClockwise>
              <b-tooltip
                :target="'replace' + id"
                variant="secondary"
                placement="bottom"
                >Replace</b-tooltip
              >
            </a>
            <a
              v-else-if="displayUrl !== null && !required"
              :id="'remove' + id"
              :class="[$style.fileActionButton]"
              @click="removeFile"
              ><BIcon class="db" icon="trash"></BIcon>
              <b-tooltip
                :target="'remove' + id"
                variant="secondary"
                placement="bottom"
                >Delete</b-tooltip
              >
            </a>
            <!-- <div>
              <a v-if="file !== null || savedFileUrl !== null" @click="removeFile"
                >remove</a
              >
            </div> -->
          </div>
        </div>
        <!-- when load image(spinner) -->
        <div v-if="loading" :class="$style.fileImageOptionLoad">
          <b-icon
            icon="arrow-clockwise"
            animation="spin-pulse"
            :class="$style.fileImageOptionIcon"
          ></b-icon>
        </div>

        <!-- when hover/ view image  (eye icon)-->
        <div v-if="displayLabel !== null" :class="$style.fileImageOptionView">
          <a
            v-if="displayUrl !== null"
            id="view"
            :href="displayUrl !== null ? api[0] + displayUrl : ''"
            :target="displayUrl !== null ? '_blank' : ''"
            :class="[$style.fileActionButton]"
          >
            <b-icon icon="eye-fill" :class="$style.fileImageOptionIcon"></b-icon
          ></a>
        </div>

        <!-- is verified -->
        <span
          v-if="displayUrl !== null && isVerified"
          :class="$style.verifiedFile"
        >
          <b-icon
            icon="check-circle-fill"
            :class="$style.verifiedIcon"
          ></b-icon>
          Verified
        </span>
      </div>
      <span :class="$style.infoText">{{ options.info }}</span>
      <span :class="$style.infoText">
        {{
          options.acceptingFiles !== undefined
            ? 'Accepting file types:' + options.acceptingFiles
            : ''
        }}</span
      >
    </div>

    <div v-if="image" :class="$style.cropImage" class="cropImage tc">
      <h5
        :class="$style.cropImageTitle"
        class="d-none d-sm-none d-md-block d-lg-block"
        >Crop Your Image</h5
      >
      <span
        :class="$style.noCrop"
        class="d-block d-sm-block d-md-none d-lg-none"
        @click="skip"
        >Skip Crop</span
      >
      <Cropper
        classname="cropper"
        :src="imageToCrop"
        @change="change"
      ></Cropper>

      <span
        class="d-none d-sm-none d-md-block d-lg-block"
        :class="$style.noCrop"
        @click="skip"
        >Skip Crop</span
      >

      <div :class="$style.modalfooter" class="cropFooter">
        <div :class="[$style.buttonWrapper]" class="pb40-sm">
          <button
            type="button"
            class="buttonCommon buttonCancel button mr10"
            @click="cancel()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="buttonCommon buttonPrimary button"
            v-on="$listeners"
            @click="setImage"
          >
            Crop
          </button>
        </div>
      </div>
    </div>
    <div :class="$style.toasterMainWrap">
      <b-toast
        :id="'verify' + name + ids"
        solid
        no-auto-hide
        b-toaster-top-right
      >
        <div
          class="d-flex"
          :class="
            showSuccess
              ? [$style.loginToasterWraper, $style.success]
              : [$style.loginToasterWraper, $style.error]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
    <!-- Loader -->
    <div v-if="saveLoading" :class="$style.loader">
      <svg
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="64px"
        height="64px"
        viewBox="0 0 128 128"
        xml:space="preserve"
      >
        <g>
          <path
            d="M78.75 16.18V1.56a64.1 64.1 0 0 1 47.7 47.7H111.8a49.98 49.98 0 0 0-33.07-33.08zM16.43 49.25H1.8a64.1 64.1 0 0 1 47.7-47.7V16.2a49.98 49.98 0 0 0-33.07 33.07zm33.07 62.32v14.62A64.1 64.1 0 0 1 1.8 78.5h14.63a49.98 49.98 0 0 0 33.07 33.07zm62.32-33.07h14.62a64.1 64.1 0 0 1-47.7 47.7v-14.63a49.98 49.98 0 0 0 33.08-33.07z"
            fill="#ff6017"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 64 64"
            to="-90 64 64"
            dur="400ms"
            repeatCount="indefinite"
          ></animateTransform>
        </g>
      </svg>
    </div>
    <!-- Loader -->
    <div>
      <b-modal
        id="show-signature"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Warning</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText"
              >Your signature is needed to verify this file. Please upload your
              signature in the 'Profile Settings' page.</p
            >
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('show-signature')"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        :id="name"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText">{{ message }}</p>
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide(name)"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="fileChange(changeFile)"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        :id="name + ids + 'verify'"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText">{{ message }}</p>
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide(name + ids + 'verify')"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="fileChange(changeFile)"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.noCrop {
  font-family: 'OpenSansBold', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 14px;
  color: #ff5d15 !important;
  cursor: pointer;
}

.infoText {
  display: block;
  font-size: 11px;
  font-style: italic;
  line-height: 14px;
  color: #8c959f;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.5);

  svg {
    position: fixed;
    top: calc(50vh - 32px);
    left: calc(50vw - 32px);
  }
}

.verifiedFile {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  padding: 1px 3px;
  font-size: 11px;
  color: #fff !important;
  text-align: center;
  background: #56cca5;

  .verifiedIcon {
    color: #fff !important;
  }
}

.fileActionButton:hover {
  color: #ff5d15 !important;
  border-color: #ff5d15 !important;
}

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  &.planeModal {
    .modalHeader {
      padding: 25px 30px 5px 30px;
      background: #fff;
      border: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .modalIcon {
      display: block;
      width: 100px;
      height: 100px;
      margin: 20px auto;
      background: url('~@assets/images/information.png') no-repeat;
      transform: scale(0.9);
      transform-origin: top;
    }
    .modalTitle {
      float: none;
      text-align: center;
    }
    .modalText {
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: #818284;
      text-align: center;
    }
    .modalBody {
      padding: 0 30px 40px 30px;
    }
  }
}
// Modal

//  Form File Upload

.formGroup {
  max-width: 500px;
}

/*
.infoText {
  display: block;
  font-size: 11px;
  font-style: italic;
  line-height: 14px;
  color: #8c959f;
} */

// crop image
.cropImageTitle {
  font-family: 'OpenSansBold', Helvetica Neue, sans-serif, Apple Color Emoji;
  font-size: 17px;
  color: $color-main-title;
  text-align: center;
  text-decoration: none;
}
// crop image

@media (max-width: 767px) {
  .fileName {
    width: 200px !important;
  }
}
</style>
